// DQ-8736 — keeps the browser tab title in sync with the current route.

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useAppTranslation } from "./useAppTranslation";
import { buildDocumentTitle, getPageTitleKey } from "../utils/pageTitles";

/**
 * Sets `document.title` to `DQ | <Page Name>` for the active route and updates
 * it on every client-side navigation. Mounted once inside the router so no
 * individual page has to manage its own title.
 */
export const useDocumentTitle = (): void => {
  const { pathname } = useLocation();
  const { t } = useAppTranslation();

  useEffect(() => {
    const pageName = t(getPageTitleKey(pathname));
    document.title = buildDocumentTitle(pageName);
  }, [pathname, t]);
};
